import { DownloadSimple, UploadSimple } from "@phosphor-icons/react";
import { api, act, useFetch, fmtDate } from "@/lib/api";
import { PageHeader, Panel, Badge, Empty } from "@/components/common";
import { Button } from "@/components/ui/button";

const exportWash = async () => {
  const r = await act(() => api.get("/calls/dncr-export", { responseType: "blob" }));
  if (!r) return;
  const a = document.createElement("a");
  a.href = URL.createObjectURL(r);
  a.download = "dncr_wash.csv";
  a.click();
};

export default function Calls() {
  const { data, reload } = useFetch("/calls");
  const upload = async (file) => {
    const fd = new FormData();
    fd.append("file", file);
    const r = await act(() => api.post("/calls/dncr-import", fd));
    if (r) import("sonner").then(({ toast }) => toast.success(`DNCR results applied: ${r.updated} contacts, ${r.registered} registered (blocked)`));
  };
  return (
    <div data-testid="calls-page">
      <PageHeader eyebrow="S14–S16 · Voice qualifier" title="AI calls" desc="Calls only contacts with recorded call permission AND a DNCR wash under 30 days old, inside AU calling hours (Mon–Fri 9–8, Sat 9–5). The agent discloses it is an AI, never records, and stops on request.">
        <Button variant="secondary" data-testid="dncr-export-btn" onClick={exportWash} className="gap-1"><DownloadSimple /> Numbers to wash</Button>
        <label className="inline-flex"><input type="file" accept=".csv" hidden data-testid="dncr-import-input" onChange={(e) => { e.target.files[0] && upload(e.target.files[0]); e.target.value = ""; }} />
          <span className="cursor-pointer inline-flex items-center gap-1 h-9 px-4 rounded-md text-sm bg-[#007AFF] hover:bg-[#3395FF] transition-colors"><UploadSimple /> Import DNCR results</span></label>
        <Button variant="secondary" onClick={reload} data-testid="calls-refresh-btn">Refresh</Button>
      </PageHeader>
      {!data?.length ? <Empty>No calls yet. Call steps run from sequences, or use “AI call now” on a contact.</Empty> : (
        <div className="space-y-3">{data.map((c) => (
          <Panel key={c.id} title={`${c.contact.name} · ${c.contact.company}`} action={<div className="flex gap-2 items-center"><Badge v={c.status} /><Badge v={c.outcome || "—"} tone="blue" /><span className="text-[11px] font-mono text-zinc-500">{fmtDate(c.created_at)}</span></div>} data-testid={`call-${c.id}`}>
            <div className="grid md:grid-cols-2 gap-4 text-xs">
              <div className="space-y-1 max-h-48 overflow-y-auto font-mono">{(c.turns || []).map((t, i) => <div key={i} className={t.role === "user" ? "text-zinc-200" : "text-[#3395FF]"}>{t.role === "user" ? "Prospect" : "AI"}: {t.content}</div>)}</div>
              <div><div className="font-mono uppercase text-zinc-500 mb-1">Qualification evidence</div>
                {Object.keys(c.qualification || {}).length ? Object.entries(c.qualification).map(([k, v]) => <div key={k}><span className="text-zinc-500">{k}:</span> {v}</div>) : <span className="text-zinc-500">Nothing captured — fields are never guessed.</span>}
                {c.error && <div className="text-[#FF6961] mt-2">{c.error}</div>}</div>
            </div>
          </Panel>
        ))}</div>
      )}
    </div>
  );
}
